import type { SelectProps as AntdSelectProps } from 'antd';
import type { FieldValues, Path } from 'react-hook-form';

import React from 'react';

import { Select as SelectAntd } from 'antd';
import clsx from 'clsx';

type SelectProps<TFieldValues extends FieldValues> = AntdSelectProps & {
  id?: string;
  placeholder?: string;
  name?: Path<TFieldValues>;
  onChange?: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  className?: string;
};

const Select = <TFieldValues extends FieldValues>(
  props: SelectProps<TFieldValues>
) => {
  const {
    name,
    id,
    placeholder,
    options,
    onChange,
    defaultValue,
    className,
    getPopupContainer,
    value
  } = props;

  if (!name || !onChange) {
    return null;
  }

  return (
    <SelectAntd
      options={options}
      placeholder={placeholder}
      id={id}
      value={value}
      onChange={onChange}
      className={clsx(
        '!bg-body !rounded-md !h-[36px] focus:!border-[#121310] hover:!border-[#121310] !outline-none !shadow-none',
        className
      )}
      defaultValue={defaultValue}
      getPopupContainer={getPopupContainer}
    />
  );
};

Select.displayName = 'Select';

export { Select };
export type { SelectProps };
